/* eslint-disable import/prefer-default-export */
import { createStoreActions } from './actions';
import getters from './getters';
import mutations from './mutations';

export const createStoreModule = ({
  service,
} = {}) => ({
  namespaced: true,
  actions: createStoreActions(service),
  getters,
  mutations,
  state: () => ({
    byId: {},
    allIds: [],
  }),
});
